import React from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import { Field, reduxForm, change, SubmissionError } from "redux-form";


const mapState = (state) => {
	return {
		nombre: state.global.nombre,
		cliente: state.global.clienteUnico,
		ramo: state.polizas.ramoActual,
		telefono: state.miPerfil.numCelOtp
	};
};

class CallCenterForm extends React.Component {

	render() {
		const { handleSubmit, submitting} = this.props;

		var margen = classnames({
			"text-content": true,
			"mt-34": !this.props.mobile
		});

		return (

			<div className="poliza-form directorio-wrap datos-wrap">
			{ this.props.mobile && this.props.mostraratras &&
				<img onClick={this.props.goBack} className="poliza-back-arrow" src={ require("../img/arrow-back.svg") } />
			}
			<div className={margen}>
				<div>
					<div>
						<h5>
							{ !this.props.mobile &&
								<img onClick={this.props.goBack} className="poliza-back-arrow" src={ require("../img/arrow-back.svg") } />
							}
							<i><img src={ require("../img/icon-cellphone.svg") } alt=""/></i>Asesoria vía telefónica
						</h5><br />
						<p style={{"textAlign":"justify"}}>En esta sección puedes recibir ayuda de un agente vía telefónica.</p><br />
						<p style={{"textAlign":"justify"}}>Para solicitarla ingresa alguna opción y da clic en llamanos. </p>
				<table>
				 <div className="input-wrap">
				  <tbody>
						<tr>
						<td>{ this.props.nombre } seleccione un motivo:
						<select id="click2callCmbId">
							<option value="ases">Asesoría</option>
							<option value="pago">Pago</option>
							<option value="reno">Renovación</option>
							<option value="cons">Consulta</option>
							<option value="soli">Solicitud</option>
						</select>
						</td>
						</tr>
						<tr>
						<td></td>
						</tr>
						<tr>
						</tr>
						<tr>
						<td></td>
						</tr>
						<tr>
						<div class="container">
							<div class="row col-xs-18">
							<td  class="col-xs-6"><button className="orange-btn" id="click2CallBtnId" onClick={() => _call.clickToCall( this.props.nombre, this.props.cliente, this.props.ramo, this.props.telefono)} style={{"display":"block"}}>LLamanos</button></td>
							<td  class="col-xs-6"></td>
							<td  class="col-xs-6"><button className="orange-btn" id="cancel2CallBtnId" onClick={() => _call.cancelCall()} style={{"display":"none"}}>Cancelar</button></td>
							</div>
						</div>				
						</tr>
					</tbody>
					</div>
				</table>
						</div>
				</div>
			</div>
			</div>
		);
	}
}
CallCenterForm = reduxForm({
	form: "videollamada"
})(CallCenterForm);

export default connect(mapState)(CallCenterForm);



// WEBPACK FOOTER //
// ./src/home/callCenter.frm.js